import { gql } from '@apollo/client';

export const updatePushNotificationTemplate = gql`
  mutation updatePushNotificationTemplate($type: String, $locale: String, $title: String, $messageBody: String) {
    updatePushNotificationTemplate(type: $type, locale: $locale, title: $title, messageBody: $messageBody) {
    status
    errorMessage
      id
      type
      locale
      title
      messageBody
    }
  }
`;
